import * as React from "react"

export interface JobActivityStatItem {
  id: string
  label: string
  /** Renders with stronger foreground (e.g. percent complete). */
  emphasis?: boolean
  /** Shows a green status dot before the label. */
  showReadyDot?: boolean
}

export interface JobActivityStatsProps {
  items: JobActivityStatItem[]
}

/** Inline, dot-separated job stats (e.g. "12 ready · 38 left · 24%"). */
export function JobActivityStats({ items }: JobActivityStatsProps) {
  if (items.length === 0) return null

  return (
    <p className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-[11px] leading-none tabular-nums text-muted-foreground">
      {items.map((item, index) => (
        <React.Fragment key={item.id}>
          {index > 0 ? (
            <span className="text-border/80" aria-hidden>
              ·
            </span>
          ) : null}
          <span className="inline-flex items-center gap-1">
            {item.showReadyDot ? (
              <span className="size-1.5 rounded-full bg-status-success" aria-hidden />
            ) : null}
            <span className={item.emphasis ? "font-medium text-foreground/80" : undefined}>
              {item.label}
            </span>
          </span>
        </React.Fragment>
      ))}
    </p>
  )
}
